import { z } from "zod";

export const ConversationListItemSchema = z.object({
  id: z.string(),
  name: z.string(),
  createdAt: z.string(),
  lastMessageAt: z.string().nullable(),
  awaitingUserInput: z.boolean(),
  agentInstructions: z.string().nullable(),
  project: z.object({ id: z.string(), name: z.string() }).nullable(),
  snippet: z.string().optional(),
});

export type ConversationListItem = z.infer<typeof ConversationListItemSchema>;

export const ConversationListPageSchema = z.object({
  items: z.array(ConversationListItemSchema),
  nextOffset: z.number().int().nullable(),
});

export type ConversationListPage = z.infer<typeof ConversationListPageSchema>;

export function parseConversationListPage(data: unknown): ConversationListPage {
  return ConversationListPageSchema.parse(data);
}

export const ConversationSearchResultSchema = z.object({
  id: z.string(),
  name: z.string(),
  createdAt: z.string(),
  lastMessageAt: z.string().nullable(),
  projectId: z.string().nullable(),
  projectName: z.string().nullable(),
  snippet: z.string().optional(),
});

export const ConversationSearchPageSchema = z.object({
  items: z.array(ConversationSearchResultSchema),
  nextOffset: z.number().int().nullable(),
});

export const CONVERSATION_PAGE_SIZE = 20;
